const FinancialBill = () => {
  return <div>FinaancialBill</div>;
};

export default FinancialBill;
